var components = {'uIcon': require('@/uni_modules/uview-ui/components/u-icon/u-icon.vue').default}
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"u-radio",class:[("u-radio-label--" + (_vm.parentData.iconPlacement)), _vm.parentData.borderBottom && _vm.parentData.placement === 'column' && 'u-border-bottom'],style:([_vm.radioStyle]),on:{"click":function($event){$event.stopPropagation();
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.wrapperClickHandler).apply(void 0, arguments)
}}},[_c('v-uni-view',{staticClass:"u-radio__icon-wrap",class:_vm.iconClasses,style:([_vm.iconWrapStyle]),on:{"click":function($event){$event.stopPropagation();
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.iconClickHandler).apply(void 0, arguments)
}}},[_vm._t("icon",[_c('u-icon',{staticClass:"u-radio__icon-wrap__icon",attrs:{"name":"checkbox-mark","size":_vm.elIconSize,"color":_vm.elIconColor}})])],2),_c('v-uni-text',{staticClass:"u-radio__text",style:({
			color: _vm.elDisabled ? _vm.elInactiveColor : _vm.elLabelColor,
			fontSize: _vm.elLabelSize,
			lineHeight: _vm.elLabelSize
		}),on:{"click":function($event){$event.stopPropagation();
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.labelClickHandler).apply(void 0, arguments)
}}},[_vm._v(_vm._s(_vm.label))])],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }